import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import TicketForm from "../../components/support/TicketForm";
import { supportTicketService } from "../../services/supportTicketService";
import { useMessageModal } from "../../admin/contexts/MessageModalContext";
import type { CreateTicketPayload } from "../../types/supportTicket";
import "../../assets/supportTickets.css";

const CreateSupportTicket: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { showModal } = useMessageModal();

  const handleSubmit = async (payload: CreateTicketPayload) => {
    try {
      setLoading(true);
      const res = await supportTicketService.createTicket(payload);
      if (res.message) {
        showModal({
          type: "success",
          title: "Success",
          message: "Support ticket created successfully.",
        });
      }
      navigate("/support");
    } catch (error) {
      console.error("Create ticket failed", error);
      if (error) {
        showModal({
          type: "error",
          title: "Failed",
          message: "Failed to create support ticket.",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="support-page-wrap">
      <div className="support-card">
        <div className="support-card-header">
          <h2>
            <i className="fa fa-life-ring" /> Create New Support Ticket
          </h2>
          <div className="ticket-breadcrumb">
            <Link to="/support">Back to Tickets</Link>
          </div>
        </div>

        <TicketForm onSubmit={handleSubmit} loading={loading} />
      </div>
    </div>
  );
};

export default CreateSupportTicket;
